import { omitBy, isNil, isUndefined } from "lodash";
import { UserCreationInput } from "Types/user.types";
import { useSession } from "Hooks/index";

const { org } = useSession();

const model = (data: UserCreationInput) => {
  // check swagger for attachments format
  // it was an object when this code was written
  // change if needed
  const attachments = [
    {
      fileName: data?.nric_passport?.fileName,
      fileType: "DOCUMENT",
      base64String: data?.nric_passport?.base64String,
    },
  ];

  const emergencyContactNumber = {
    countryCode: data?.emergencyContactNo?.dialCode ?? null,
    number: data?.emergencyContactNo?.number ?? null,
    fullNumber:
      data?.emergencyContactNo?.number != undefined
        ? `${data?.emergencyContactNo?.dialCode}${data?.emergencyContactNo?.number}`
        : null,
  };
  // Check if any of the sub-properties of emergencyContactNumber are undefined or null
  const isEmergencyContactNumberUndefined = Object.values(emergencyContactNumber || {}).some(isNil);

  if (data.id) {
    return omitBy(
      {
        profileID: data.id,
        locationID: data?.location ?? null,
        data: omitBy(
          {
            orgID: data.orgID,
            userSubType: data.subType?.replace(" ", "_"),
            primaryPhone: {
              countryCode: data.mobileNo?.dialCode,
              number: data?.mobileNo?.number,
              fullNumber: `${data?.mobileNo?.dialCode}${data?.mobileNo?.number}`,
            },
            primaryEmail: data.email,
            fullName: data?.fullName,
            department: data?.department,
            identification: {
              type: data?.idPassportType,
              no: data?.idPassportNo,
            },
            userType: org.orgType,
            primaryAddress: {
              street1: data.street1,
              street2: data?.street2,
              city: data.city,
              state: data.state,
              postcode: data.postcode,
              country: data.country,
            },
            gender: data.gender,
            payrollData: {
              bankType: data.bankType,
              accountNumber: data.accountNo,
              SOCSONo: data?.socsoNo,
              incomeTaxNo: data?.incomeTax,
              EPFNo: data?.epfNo,
              zakatNo: data?.zakatNo,
              HRDFNo: data?.hrdfNo,
            },
            emergencyContactName: data.emergencyContactName ?? null,
            ...(isEmergencyContactNumberUndefined ? {} : { emergencyContactNumber }),
          },
          isNil
        ),
      },
      isNil
    );
  }
  return omitBy(
    {
      orgID: data?.orgID,
      locationID: data?.location ?? null,
      userSubType: data.subType?.replace(" ", "_"),
      primaryPhone: {
        countryCode: data?.mobileNo?.dialCode,
        number: data?.mobileNo?.number,
        fullNumber: `${data?.mobileNo?.dialCode}${data?.mobileNo?.number}`,
      },
      primaryEmail: data.email,
      fullName: data?.fullName,
      department: data?.department,
      identification: {
        type: data?.idPassportType,
        no: data?.idPassportNo,
      },
      userType: org.orgType,
      attachments: attachments,
      primaryAddress: {
        street1: data.street1,
        street2: data?.street2,
        city: data.city,
        state: data.state,
        postcode: data.postcode,
        country: data.country,
      },
      gender: data.gender,
      payrollData: {
        bankType: data.bankType,
        accountNumber: data.accountNo,
        SOCSONo: data?.socsoNo,
        incomeTaxNo: data?.incomeTax,
        EPFNo: data?.epfNo,
        zakatNo: data?.zakatNo,
        HRDFNo: data?.hrdfNo,
      },
      emergencyContactName: data?.emergencyContactName ?? null,
      ...(isEmergencyContactNumberUndefined ? {} : { emergencyContactNumber }),
      emergencyRelationship: data.relationship,
    },
    isNil
  );
};

export default model;
